import React, { Fragment } from 'react'
import { NavLink } from "react-router-dom";

interface IProps
{
    id:number,
    url:string
}
export  const AccountChangeHistoryTabs = ({ id, url }) => {
    return (
        <Fragment>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item">
                    <NavLink to={"/Account-change-history/detail/" + id} className={url=="/Account-change-history/detail/"?"nav-link active":"nav-link"} id="edit-tab" data-toggle="tab" href="#edit" role="tab"
                        aria-controls="edit" aria-selected={url=="/Account-change-history/detail/"?"true":"false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                </li>
            </ul>
            <br/>
        </Fragment>
    )
}